import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import SignupWeb from './web';
import SignupMob from './mob';

const Signup = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <SignupMob /> : <SignupWeb />;
};

export default Signup;
